import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

const hoverState = '&:not([disabled]):hover, &:not([disabled])[data-hover]'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.fileUpload', {
      fileItemWrapper: {
        mb: '2x',
        width: '100%',
      },
      btnTips: {
        color: 'mute',
        mb: '3x',
        mt: 'x',
        fontSize: '12px',
        lineHeight: '18px',
      },
      baseText: {
        fontSize: '14px',
        lineHeight: '22px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      icon: {
        ml: 10,
        cursor: 'pointer',
        [hoverState]: {
          opacity: '0.8',
        },
      },
      text: {
        maxWidth: 345,
        'cmp.fileUpload': 'baseText',
      },
      errorText: {
        fontSize: '12px',
        lineHeight: '18px',
        mt: 8,
        color: 'danger',
      },
      fileItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      fileItemRO: {
        wrapper: {
          pt: '5px',
          display: 'flex',
          alignItems: 'center',
        },
        text: {
          'cmp.fileUpload': 'baseText',
          cursor: 'pointer',
          maxWidth: 348,
          [hoverState]: {
            color: 'brand',
          },
        },
      },
      progress: {
        height: 4,
        width: '100%',
        borderRadius: '2px',
        bg: '#F5F7FC',
        mt: 8,
        position: 'relative',
        overflow: 'hidden',
        '&:before': {
          borderRadius: '2px',
          position: 'absolute',
          content: '""',
          left: 0,
          height: 4,
          bg: 'brand',
        },
      },
    }),
  ]
}
